import {
  Button,
  Stack,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';

import { ProjectInstallationMetric } from 'modules/components/layer05';
import { SaveInstallationModal } from 'modules/components/layer17';

import React, { useState } from 'react';

import * as ds from './dataService';

import _ from 'lodash';

import { useParams } from 'react-router-dom';

import { useReactiveVar } from '@apollo/client';
import { reactiveVariables } from 'modules/common/layer00';



export type InstallationsSummaryMetricsSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationsSummaryMetricsSectionProps) => {
  const params = useParams();

  const { data } = ds.useQuery(params.projectId ?? '');
  const metricNames: (keyof typeof data)[] = [
    'completedFinish',
    'overdueFinish',
    'upcomingFinish',
    'remainingSelections'
  ];
  return (
    <Stack
      flex='1 1 0'
      direction='row'
    >
      {
        metricNames.map((node, i) => (
          <ProjectInstallationMetric.FC
            key={i}
            count={data[node]}
            title={metricName2Title[node]}
            metricType={node}
          />

        ))
      }
    </Stack>
  );
};


const metricName2Title: Record<keyof ds.IData, string> = {
  completedFinish: 'Completed Selection(s)',
  overdueFinish: 'Overdue Selection(s)',
  remainingSelections: 'Remaining Selection(s)',
  upcomingFinish: 'Upcoming Selection(s)'
};


type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const theme = useTheme();
  const installationFilter = useReactiveVar(reactiveVariables.filterInstallationsVar);
  return (
    <>
      {isVisible && (
        <SaveInstallationModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      { !_.valuesIn(installationFilter).every((r) => r === true || r === '' || _.isNull(r)) && (

        <Button
          variant='contained'
          onClick={() => reactiveVariables.resetInstallationFilter()}
        >
          Reset Filter
        </Button>
      )}
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SPARKLE'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create New Finish
      </Button>

    </>
  );
};

